import React, { FC, PropsWithChildren, ReactNode, RefObject } from 'react';
import { styled } from 'linaria/react';
import { withTheme } from '@shared/lib/theme';
import { Text } from '@shared/ui/atoms';
import { CrossIcon } from '@shared/assets/icons';
import { BottomSheetProps } from './BottomSheet';
interface BottomSheetContentProps extends Pick<BottomSheetProps, 'onClose'> {
  title?: ReactNode;
  scrollableRef?: RefObject<HTMLElement | null>;
}
const BottomSheetContent: FC<BottomSheetContentProps & PropsWithChildren> = ({
  title = '',
  onClose,
  scrollableRef,
  children
}) => <BottomSheetContentWrapper>
    <BottomSheetTopWrapper>
      {title && <Text family="MTSWide" size="pL" weight="medium" color="primary">
          {title}
        </Text>}
      <IconButtonWrapper type="button" onClick={onClose}>
        <CrossIcon />
      </IconButtonWrapper>
    </BottomSheetTopWrapper>
    <ContentWrapper ref={scrollableRef as RefObject<HTMLDivElement>}>{children}</ContentWrapper>
  </BottomSheetContentWrapper>;
export default BottomSheetContent;
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.primary;
const BottomSheetContentWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "BottomSheetContentWrapper",
  class: "b1ta897",
  propsAsIs: false,
  vars: {
    "b1ta897-0": [_exp()]
  }
}));
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.primary;
const BottomSheetTopWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "BottomSheetTopWrapper",
  class: "b1uj85g5",
  propsAsIs: false,
  vars: {
    "b1uj85g5-0": [_exp2()]
  }
}));
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.icon.tertiary;
const IconButtonWrapper = withTheme(/*#__PURE__*/styled('button')({
  name: "IconButtonWrapper",
  class: "i5ul8bg",
  propsAsIs: false,
  vars: {
    "i5ul8bg-0": [_exp3()]
  }
}));
const ContentWrapper = /*#__PURE__*/styled('div')({
  name: "ContentWrapper",
  class: "cqidg2s",
  propsAsIs: false
});

require("./BottomSheetContent.linaria.module.css!=!../../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./BottomSheetContent.tsx");